module.exports = __webpack_public_path__ + "static/img/7.31d955c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/3/zh/7.png
// module id = 2T2M
// module chunks = 0